<template>
  <div class="diy-follow" v-if="isSubscribe != 1 && biz != null">
    <img v-if="avatarUrl != ''" :style="{borderRadius: '3px'}"
         :src="avatarUrl" style="width: 36px; height: 36px;margin-left: 7px; min-width: 36px;"/>
    <span
      style="margin: 0 7px;width: 206px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;text-overflow:ellipsis;overflow: hidden;">{{
        content
      }}</span>
    <div class="btn" :style="{color:'#ffffff',backgroundColor:'#04bf02'}"
         @click="followClick">
      关注
    </div>
    <nut-dialog title="长按识别关注" :visible="dialogShow" :close-btn="true" @close="dialogShow=false"
                @on-close-btn="dialogShow=false" :no-footer="true">
      <div style="display: flex;flex-direction: column; align-items: center;">
        <!--<img :style="{borderRadius:diyItem.params.iconshape === 0 ? '3px' : '50%'}"
             :src="avatarUrl" style="width: 36px; height: 36px;margin-left: 7px; min-width: 36px;display: block;"/>-->
        <vue-qr :margin="20" :size="200" :text="url"/>
      </div>
    </nut-dialog>
  </div>
</template>

<script>
import VueQr from 'vue-qr'

export default {
  name: 'TPFollow',
  components: { VueQr },
  props: {
    //是否关注
    'subscribe': {
      type: Number,
      default: 0
    },
    //关注跳转公众号 为空时不显示关注组件
    'biz': {
      type: String,
      default: null
    },
    //关注组件描述字段
    'info': {
      type: String,
      default: '欢迎访问[商城名称]，点击关注我们哦~'
    },
    //关注组件[商城名称]
    'name': {
      type: String,
      default: ''
    },
    //打开类型 url 1 , 二维码 0
    'openType': {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      isSubscribe: this.subscribe,
      imgUrl: sessionStorage.getItem ('url'),
      avatarUrl: '',
      content: this.info,
      url: null,
      dialogShow: false
    }
  },
  watch:{
    'biz'(val){
      let biz = val
      this.url = `https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=${biz}#wechat_redirect`
    }
  },
  created() {
    //头像处理
    //if (icontype == 1) {//商城log
    //this.avatarUrl = this.imgUrl + this.$api.system.sellerInfoData.logImg
    //}

    //描述文字处理
    this.content = this.content.replace ('[商城名称]', this.name)
  },
  methods: {
    followClick() {
      if (this.openType === 1) {
        window.open (this.url)
      }
      if (this.openType === 0) {
        this.dialogShow = true
      }
    },
    closeDialog() {
      this.dialogShow = false
    }
  }
}
</script>

<style scoped>
/*follow 关注组件css*/
.diy-follow {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 7px 0;
}

.diy-follow .btn {
  margin-right: 25px;
  border: none;
  border-radius: 3px;
  padding: 7px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/comp/TPFollow.vue